export default {
  title: `Forgot your password?`,
  confirmationTitle: 'Check your email',
  description: `You may need to check your spam folder or unblock info@dealbinder.com.`,
  confirmation: `If that account exists, you will receive an email with reset instructions`,
  emailPlaceholder: 'Enter your email'
};
